import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { FormattedMessage } from 'react-intl';
import FormattedPercentage from '../../FormattedPercentage';
import FormattedCurrency from '../../FormattedCurrency';
import DiscountCouponIcon from '../../icons/DiscountCouponIcon';
import AccessCouponIcon from '../../icons/AccessCoupon';
import Typography from '../../Typography';

class CouponBanner extends Component {
  static propTypes = {
    coupon: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  };

  renderDiscount() {
    const { discountPercentage, discountValue } = this.props.coupon;
    return discountPercentage ? (
      <FormattedPercentage value={discountPercentage} />
    ) : (
      <FormattedCurrency value={discountValue} />
    );
  }

  renderExpiration() {
    const { dateRange } = this.props.coupon;
    return dateRange && dateRange.end ? (
      <FormattedMessage
        id="couponBannerRuleExpiration"
        values={{ date: new Date(dateRange.end) }}
      />
    ) : (
      ''
    );
  }

  renderMaxTickets() {
    const { maxTicketsByCoupon } = this.props.coupon;
    return maxTicketsByCoupon ? (
      <FormattedMessage id="couponBannerRuleMaxTickets" values={{ max: maxTicketsByCoupon }} />
    ) : (
      ''
    );
  }

  renderIcon() {
    const {
      classes,
      coupon: { type },
    } = this.props;
    switch (type) {
      case 'access':
        return <AccessCouponIcon className={classes.icon} />;
      case 'discount':
      default:
        return <DiscountCouponIcon className={classes.icon} />;
    }
  }

  getMessageId() {
    const {
      coupon: { discountPercentage, discountValue, type },
    } = this.props;
    if (type === 'access') {
      if (discountPercentage || discountValue) {
        return 'accessAndDiscountCouponBannerRule';
      } else {
        return 'accessCouponBannerRule';
      }
    }
    return 'discountCouponBannerRule';
  }

  render() {
    const { coupon, classes } = this.props;

    if (coupon.type === 'discount' && !coupon.discountPercentage && !coupon.discountValue) {
      return null;
    }

    return (
      <div className={classes.root}>
        <div className={classes.iconAndCode}>
          {this.renderIcon()}
          <Typography className={classes.code} type="caption">
            <FormattedMessage
              id="couponBannerCode"
              values={{ coupon: coupon.code.toUpperCase() }}
            />
          </Typography>
        </div>
        <Typography className={classes.description} type="caption">
          <FormattedMessage
            id={this.getMessageId()}
            values={{
              discount: this.renderDiscount(),
              expiration: this.renderExpiration(),
              maxTickets: this.renderMaxTickets(),
            }}
          />
        </Typography>
      </div>
    );
  }
}

const stylesheet = theme => ({
  root: {
    marginBottom: theme.spacing.small,
  },
  iconAndCode: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.success[500],
    marginRight: theme.spacing.xsmall,
  },
  code: {
    fontWeight: 'bold',
  },
  description: {
    marginLeft: theme.spacing.medium + theme.spacing.xsmall,
  },
});

export default injectSheet(stylesheet)(CouponBanner);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/Coupon/CouponBanner.js